import React from 'react';
import { Violator } from '@hpi-sox/hpstellar-core';

import useProductPrice from '../../hooks/useProductPrice';
import { getSaleCalloutText } from '../../product/get-product-props';
import DealViolator from '../../product/components/deals/deal-violator';

export default ({ product }) => {
    const { metadata } = product || {};
    const { saleCallout, intraDayMessage } = metadata || {};
    const { prices } = useProductPrice([product]);
    const price = prices[product.sku];
    const { deal } = price || {};
    const { activeDeal } = deal || {};
    let promoText = getSaleCalloutText(saleCallout, price);

    if (!promoText && !activeDeal) return null;

    return activeDeal ? (
        <Violator variation="primary" className="sale-callout">
            <DealViolator activeDeal={activeDeal} price={price} message={intraDayMessage} className="secondary" />
        </Violator>
    ) : (
        <Violator variation="secondary" small className="sale-callout">
            {promoText}
        </Violator>
    );
};
